require('./bootstrap');

import App from "./App.vue";
import Vue from 'vue'
import vuetify from './plugins/vuetify'
import { router } from './router'
import http from "./plugins/http";
import auth from "./plugins/auth";
import i18n from './plugins/i18n';
import './filters/nullify'
import "./plugins/http";
import "./plugins/api";
import "./plugins/toast";
import "./plugins/meta";
import "./plugins/can";
import "@/plugins/dayjs";
import "./plugins/roles";
import store from './store/index'

new Vue({
    http,
    router,
    i18n,
    vuetify,
    auth,
    el: '#app',
    store,
    methods:{
        getFilters(name, default_filters = []) {
            return {...default_filters, ...JSON.parse(localStorage.getItem(name + '_filters'))};
        },
        saveFilters(name, filters) {
            Object.keys(filters).forEach((key) => {
                if (filters[key] == null) {
                    delete filters[key];
                }
            });

            localStorage.setItem(name + '_filters', JSON.stringify(filters));
        },
        clearStorage() {
            localStorage.clear()
        }
    },
    render: h => h(App),
    metaInfo: {
        title: "Keroman | Kerport",
    }
})
